import styled, { css } from 'styled-components'
import { TextCallout2, TextCallout1 } from 'blocket-ui'

export const TextWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
export const Text = styled(TextCallout2)`
  font-size: 12px;
  padding-left: 5px;
`

export const Title = styled(TextCallout1)`
  padding-bottom: 2px;
  padding-left: 5px;
`

export const sharedToolTipStyles = css`
  width: 280px;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: left;
  background-color: #fff;
  text-align: left;
  border: 1px solid #cdcccc;
  border-radius: 10px;
  padding: 12px;
  user-select: none;
  position: absolute;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24);
  &:after {
    content: '';
    position: absolute;
    background-color: #fff;
    border-right: 1px solid #cdcccc;
    border-top: 1px solid #cdcccc;
  }
`
